import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";
import PopupWrapper from "./Popup.style";

const PopupScreen = ({
 visible = false,
 onHide = () => {},
 text = "",
 onClick = () => {},
 link = "",
 btnText = "renewal.errors.click_here",
 onMaskClick = () => {},
 autoRedirect = false
}) => {
 const { t } = useTranslation();
 const [secondsLeft, setSecondsLeft] = useState(100);

 useEffect(() => {
  if (!visible) return;

  // Update the countdown every second
  if (autoRedirect) {
    const interval = setInterval(() => {
        setSecondsLeft((prevSeconds) => {
         if (prevSeconds <= 1) {
          clearInterval(interval);
          window.location.href=(link); 
          return 0;
         }
         return prevSeconds - 1;
        });
       }, 1000);
     
       return () => clearInterval(interval);
  }

 }, [visible, link, autoRedirect]);

 return (
  <Dialog
   visible={visible}
   showHeader={false}
   closable={true}
   modal={true}
   onHide={onHide}
   contentStyle={{ padding: "20px", borderRadius: "10px" }}
   onMaskClick={onMaskClick}
  >
   <PopupWrapper>
    <div className="container-fluid">
     <div className="d-flex justify-content-center">
      <div>
       <p>{t(text)}</p>
       {autoRedirect?<p>You will be redirected in {secondsLeft} seconds.</p>:''}
       <div className="popup_action_btn" onClick={() => onClick(link)}>
        <p>{t(btnText)}</p>
       </div>
      </div>
     </div>
    </div>
   </PopupWrapper>
  </Dialog>
 );
};

export default PopupScreen;
